import { render, staticRenderFns } from "./block-status.vue?vue&type=template&id=5f91d624&scoped=true&"
import script from "./block-status.vue?vue&type=script&lang=js&"
export * from "./block-status.vue?vue&type=script&lang=js&"
import style0 from "./block-status.vue?vue&type=style&index=0&id=5f91d624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f91d624",
  null
  
)

export default component.exports